import React from 'react';
import { Link } from 'react-router-dom';

import './style.css';

const CtaSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <div className={`wpo-cta-area ${props.ctaclass}`}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="wpo-cta-text">
              <h2>You Can Help The Poor With Us</h2>
              <p>
                Our goals and projects will not be achieved without your
                financial support. It takes just one person to make a difference
                in child’s life. Thank you for investing in the lives of others.
              </p>
              <p>
                Give a life changing gift of sponsorship to a vulnerable or less
                fortunate child
              </p>
              <div className="btns">
                <Link
                  onClick={ClickHandler}
                  to="/sponsored-children"
                  className="theme-btn"
                >
                  Sponsor a child in Africa
                </Link>
                <Link
                  onClick={ClickHandler}
                  to="/volunteer"
                  className="theme-btn-s2"
                >
                  Join Us Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CtaSection;
